import React, { useEffect, useState } from "react";
import { Tag, Popover, notification, Form, Table, Select, Row, Col } from 'antd';

import api from '../../services/api';
import { FormGW, SelectPaginacao, TabelaDados } from "../../components";

export default function ImportarOperacao({ formulario, carregando, aoSalvar }) {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [operacoesSelecionadas, setOperacoesSelecionadas] = useState([]);
    const [dadosTabela, setDadosTabela] = useState([]);
    const [codigoLocal, setCodigoLocal] = useState(null);

    useEffect(() => {
        carregarOperacoes();
    }, [codigoLocal]);

    async function carregarOperacoes() {
        try {
            let url = 'OperacaoFiscal/OperacaoFiscalOutrosLocais?PageSize=1000&PageNumber=1';

            if (codigoLocal) {
                url += `&IdLocal=${codigoLocal}`;
            }

            const res = await api.get(url);
            const retorno = res.data.items;
            setDadosTabela(retorno);
        } catch (erro) {
            console.log(erro);
        }
    }


    function salvarOperacoes() {
        api.post(`OperacaoFiscal/ImportarOperacao`, operacoesSelecionadas).then(
            res => {
                notification.success({ message: 'Operação concluída', description: "Operações Fiscais importadas com Sucesso!" });
            }
        ).catch(
            erro => {
                notification.error({ message: 'Erro ao processar a requisição.', description: JSON.stringify(erro.response) });
            }
        ).finally(
            () => {
                carregando(false);
                aoSalvar();
            }
        );
    };

    function onSelectChange(newSelectedRowKeys) {
        setSelectedRowKeys(newSelectedRowKeys);
        const operacoes = newSelectedRowKeys.map(id => ({ ope_id: id }));
        setOperacoesSelecionadas(operacoes);
    }

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    return (
        <Form layout="vertical" form={formulario} name="manutencaoMetas" onFinish={salvarOperacoes}>
            <div className="p-10">
                <div className="tabela">
                    <Row align="middle" gutter={[0, 16]}>
                        <Col span={24}>
                            <Form.Item label="Selecione um Local" name="filial">
                                <SelectPaginacao url="Local/ListarLocalUsuario" placeholder="Selecione um local" selecionarRegUnico="est_sigla" allowClear={true}
                                    form={formulario} nameLabel="loc_descricao" nameValue="filial"
                                    onChangeFunction={(valor) => setCodigoLocal(valor)}
                                    conteudo={
                                        Local => (<Select.Option key={Local.loc_id} value={Local.loc_id} label={Local.loc_descricao}> {Local.loc_descricao} </Select.Option>)
                                    } />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Table
                        rowKey="ope_id"
                        rowSelection={rowSelection}
                        dataSource={dadosTabela}
                        pagination={{ pageSize: 20 }}
                        columns={[
                            {
                                title: 'Código',
                                width: 75,
                                align: 'center',
                                render: ({ ope_id, ope_ativo }) => (
                                    <Popover content={ope_ativo ? 'Ativo' : 'Inativo'} placement="right">
                                        <Tag color={ope_ativo ? 'processing' : 'default'} className="w-100">
                                            <b>{ope_id}</b>
                                        </Tag>
                                    </Popover>
                                ),
                            },
                            {
                                title: 'Operação Fiscal',
                                render: ({ ope_descricao }) => (
                                    <div>
                                        <b>{ope_descricao}</b>
                                    </div>
                                ),
                            }
                        ]}
                    />
                </div>
            </div>
        </Form >
    );
}